import React from 'react';
import Input from '@material-ui/core/Input';
import { Button } from '@material-ui/core';
import './Input.css';


const inputer = ({input,setInput,findweather}) => {
    const handleChange=(event)=>{
        setInput(event.target.value);
    };

    const handleClick=(event)=>{
        event.preventDefault();
        findweather();
    }
    return (
        <div className="inputBox">
            <div className="inputBox_field">
                <h1>Google Weather App</h1>
                <p>Powered by</p>
                <img src="https://www.freepnglogos.com/uploads/google-logo-png/google-logo-icon-png-transparent-background-osteopathy-16.png" alt="logo"/>
                <form>
                <Input placeholder="Enter the city name" onChange={handleChange} value={input}/><br></br>
                <Button variant="contained" color="primary" type="submit" onClick={handleClick} >Search</Button>
                </form>
            </div>
        </div>
    );
};
export default inputer;